<template>
    <div>
        <div
            id="main-wrapper"
            data-navbarbg="skin6"
            data-theme="light"
            data-layout="vertical"
            data-sidebartype="full"
            data-boxed-layout="full"
        >
            <div class="page-wrapper homepage">
                <slot>
                    <div class="homeheader">
                        <div class="row">
                            <div class="col-12 align-self-center text-center">
                                <a :href="urlPage">
                                    <!-- <img
                                        v-if="logo_lang == 'es'"
                                        src="@/assets/logo_es.png"
                                        alt="homepage"
                                        class="light-logo"
                                        width="170"
                                        style="padding-top: 13px; padding-bottom: 13px"
                                    /> -->
                                    <img
                                        src="@/assets/logo_en.png"
                                        alt="homepage"
                                        class="light-logo"
                                        width="170"
                                        style="padding-top: 13px; padding-bottom: 13px"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="bgloading" v-if="isLoading"><Loader></Loader></div>
                    <div class="container-fluid">
                        <div class="row">
                            <div
                                class="col-lg-4 col-sm-8 offset-lg-4 offset-sm-2 formloginhome"
                            >
                                <div class="card card-body" style="margin-top: 40px">
                                    <form @submit.prevent="validatelogin" class="">
                                        <div class="row">
                                            <div class="col-md-12 col-sm-12">
                                                <div class="form-row">
                                                    <div
                                                        class="form-group col-md-12 text-center"
                                                    >
                                                        <h4>
                                                            {{ $t("lang.label_sign_in") }}
                                                        </h4>
                                                    </div>
                                                    <div class="form-group col-md-12">
                                                        <div
                                                            class="alert alert-danger"
                                                            role="alert"
                                                            v-if="messageError != null"
                                                        >
                                                            {{ messageError }}
                                                        </div>
                                                        <input
                                                            id="email"
                                                            type="email"
                                                            class="form-control"
                                                            name="email"
                                                            v-model="
                                                                userCredenctial.email
                                                            "
                                                            :placeholder="[[msj_email]]"
                                                            autocomplete="email"
                                                            required
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-12">
                                                        <div class="password-input">
                                                            <span
                                                                class="showpassord icon-eye"
                                                                action="hide"
                                                                @click="
                                                                    showpassword = !showpassword
                                                                "
                                                            >
                                                                <i
                                                                    class="fas fa-eye-slash"
                                                                    v-if="showpassword"
                                                                ></i>
                                                                <i
                                                                    class="fas fa-eye"
                                                                    v-else
                                                                ></i>
                                                            </span>
                                                            <input
                                                                id="password"
                                                                :type="typepassword"
                                                                class="form-control"
                                                                v-model="
                                                                    userCredenctial.password
                                                                "
                                                                name="password"
                                                                :placeholder="[
                                                                    [label_pass],
                                                                ]"
                                                                autocomplete="new-password"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <button
                                                            type="submit"
                                                            class="btn btn-success btn-block"
                                                        >
                                                            {{ $t("lang.label_login") }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 text-center">
                                                <a class="btn btn-link" href="#">
                                                    {{ $t("lang.label_fgot_pass") }}
                                                </a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </slot>
                <footer class="footer text-center">
                    {{ $t("lang.label_all_rgts_rsrvd_by") }}
                    <a href="https://dimenu.com" target="_blank">DiMenu</a>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/shared/Loader";
export default {
    name: "HomeLayout",
    components: {
        Loader,
    },
    delimiters: ["[[", "]]"],
    data () {
        return {
            msj_email: window.lang2.msj_email,
            label_pass: window.lang2.label_pass,
            isLoading: false,
            messageError: null,
            loginok: false,
            userCredenctial: {
                email: null,
                password: null,
            },
            showpassword: false,
            typepassword: "password",
            urlPage: window.urlweb,
            logo_lang: window.langLocal,
        };
    },
    created () {
        this.isLoading = true;
        this.$store.dispatch("validToken").then((response) => {
            //console.log(response.data);
            console.log("validando token master ", response.data);
            if (response.data.tokenValid) {
                this.login();
            } else {
                console.log("salir del sistema ", response.data.tokenValid);
                this.isLoading = false;
                //this.$router.push({ name: 'Logout' });
            }
        });
    },
    methods: {
        validatelogin() {
            this.isLoading = true;
            this.messageError = null;
            this.$store
                .dispatch("loginAuxiliar", {
                    email: this.userCredenctial.email,
                    password: this.userCredenctial.password,
                })
                .then((response) => {
                    // console.log('llamar privilegios de la cuenta');
                    //llamar privilegios de la cuenta
                    this.$store.dispatch("privilegies_session").then((response) => {
                        // this.$router.push({ name: "Home" });
                        setTimeout(() => {
                            // this.isLoading = false;
                            window.location.reload(true);
                        }, 500);
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.messageError = window.lang2.msj_err_server;
                });
        },
        login() {
            let client_Org = localStorage.getItem("mark_client_data");
            let client_M = localStorage.getItem("mark_client_data_m");
            let token_M = localStorage.getItem("access_token_m");
            let oauth_M = localStorage.getItem("oauth_m");
            this.isLoading = true;
            if (
                oauth_M != null &&
                client_Org != null &&
                client_M != null &&
                token_M != null &&
                !this.$store.getters.loggedIn
            ) {
                this.$store
                    .dispatch("retrieveToken", {
                        validM: true,
                    })
                    .then((response) => {
                        //console.log('sesion master ', response.data);
                        // console.log('llamar privilegios de la cuenta');
                        //llamar privilegios de la cuenta
                        this.$store.dispatch("privilegies_session").then((response) => {
                            this.$router.push({ name: "Home" });
                        });
                    })
                    .catch((error) => {
                        //console.log(error);
                        console("error al iniciar sesion", error);
                        this.isLoading = false;
                        this.$router.push({ name: "Logout" });
                    });
            } else {
                console.log(
                    "no hay variables",
                    oauth_M,
                    client_Org,
                    client_M,
                    token_M,
                    this.$store.getters.loggedIn
                );
                this.isLoading = false;
                this.$router.push({ name: "Logout" });
            }
        },
    },
    watch: {
        showpassword: function () {
            //console.log('password show ', this.showpassword);
            if (this.showpassword) {
                this.typepassword = "true";
            } else {
                this.typepassword = "password";
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.homepage .homeheader {
    background: #000;
}
.bgloading {
    background-color: #fff;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
